import * as Dialog from '@radix-ui/react-dialog';
import Card from 'components/card';
import { IoIosCloseCircle } from 'react-icons/io';
import { TNetworkList } from 'views/types/tokens';

type TokenDetailsProps = {
  open: boolean;
  onClose: (open: boolean) => void;
  tokenData?: TNetworkList;
};

export const TokenDetailsDialog = ({
  open,
  onClose,
  tokenData,
}: TokenDetailsProps) => {
  if (!tokenData) {
    return null;
  }

  return (
    <Dialog.Root open={open} onOpenChange={onClose}>
      <Dialog.Portal>
        <Dialog.Overlay className="data-[state=open]:animate-overlayShow fixed inset-0 z-50 bg-black/30 backdrop-blur-sm" />
        <Dialog.Content className="data-[state=open]:animate-contentShow fixed top-1/2 left-1/2 z-50 h-[80vh] w-full max-w-[90vw] -translate-x-1/2 -translate-y-1/2 rounded-lg dark:bg-gray-800 dark:text-white bg-white p-6 shadow-xl focus:outline-none">
          <div className="absolute top-2 right-2">
            <Dialog.Close asChild>
              <button className="text-gray-500 hover:text-gray-700">
                <IoIosCloseCircle size={24} />
              </button>
            </Dialog.Close>
          </div>

          <Dialog.Title className="text-lg font-bold mb-4">
            Token: {tokenData.coin}
          </Dialog.Title>

          <Card className="space-y-2">
            <p className="flex justify-between">
              <strong>Name:</strong> <span>{tokenData.name}</span>
            </p>
            <p className="flex justify-between">
              <strong>Network:</strong> <span>{tokenData.netWork}</span>
            </p>
            <p className="flex justify-between">
              <strong>Contract:</strong> <span>{tokenData.contract}</span>
            </p>
            <p className="flex justify-between">
              <strong>Deposit Enabled:</strong>
              <span
                className={
                  tokenData.depositEnable ? 'text-green-600' : 'text-red-600'
                }
              >
                {tokenData.depositEnable ? 'Yes' : 'No'}
              </span>
            </p>
            <p className="flex justify-between">
              <strong>Withdraw Enabled:</strong>
              <span
                className={
                  tokenData.withdrawEnable ? 'text-green-600' : 'text-red-600'
                }
              >
                {tokenData.withdrawEnable ? 'Yes' : 'No'}
              </span>
            </p>
            <p className="flex justify-between">
              <strong>Withdraw Fee:</strong>{' '}
              <span>{tokenData.withdrawFee}</span>
            </p>
            <p className="flex justify-between">
              <strong>Withdraw Min:</strong>{' '}
              <span>{tokenData.withdrawMin}</span>
            </p>

            <p className="flex justify-between">
              <strong>Same Address:</strong>
              <span>{tokenData.sameAddress ? 'Yes' : 'No'}</span>
            </p>
            {tokenData.depositTips && (
              <p className="text-sm text-gray-600">
                <strong>Deposit Tips:</strong> {tokenData.depositTips}
              </p>
            )}
            {tokenData.withdrawTips && (
              <p className="text-sm text-gray-600">
                <strong>Withdraw Tips:</strong> {tokenData.withdrawTips}
              </p>
            )}
          </Card>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
